// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BookingConfirmForm = registerClientReference(
    function() { throw new Error("Attempted to call BookingConfirmForm() from the server but BookingConfirmForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/booking/BookingConfirmForm.tsx",
    "BookingConfirmForm",
);
